<template>
  <ElForm
    style="max-height: 400px; padding-right: 10px; overflow-x: hidden; overflow-y: auto"
    ref="formRef"
    label-width="120px"
    @submit.native.prevent
    :model="formData"
    :rules="rules"
  >
    <template v-if="!isBatch">
      <slot name="parent" :form-data="formData"></slot>

      <ElFormItem :prop="isAdd ? 'labels' : 'label'">
        <template #label>
          <slot name="label-name"> <span> 标签内容 </span></slot>
        </template>

        <ElInput
          v-if="isAdd"
          v-model="formData.labels"
          type="textarea"
          rows="5"
          placeholder="样式名称一行一个,每个标签不超过100个字符"
          style="width: 100%"
        >
        </ElInput>

        <ElInput v-else v-model="formData.label" style="width: 100%"> </ElInput>
      </ElFormItem>
    </template>
    <template v-if="isShowGameGroup">
      <ElFormItem label="游戏组">
        <el-select v-model="formData.gameGroupId" multiple filterable style="width: 100%" @change="onGameGroupChange" placeholder="请选择">
          <el-option v-for="item in gameGroups" :key="item.id" :label="item.name" :value="item.id"> </el-option>
        </el-select>
      </ElFormItem>

      <ElFormItem label="游戏">
        <el-select v-model="formData.gameIds" style="width: 100%" multiple filterable clearable placeholder="请选择">
          <el-option v-for="item in games" :key="item.id" :label="item.name" :value="item.id"> </el-option>
        </el-select>
      </ElFormItem>
    </template>
  </ElForm>
</template>

<script setup>
/**
 * @description: 素材样式、营销主题标签共用的表单组件
 */
import { ref, computed, useSlots } from 'vue'
import { initPageData, GAMES, GAME_GROUPS } from '@/data/global-opts'
import { FORM_TYPE, LEVEL_TYPES } from '../../const'

import { rules } from './tag-form-rules.js'

const slots = useSlots()
// 当前页面需要的下拉数据项
const PAGE_REQUIRED_OPTS = initPageData([GAMES, GAME_GROUPS])
const gameGroups = computed(PAGE_REQUIRED_OPTS.GAME_GROUPS)
const games = computed(PAGE_REQUIRED_OPTS.GAMES)

const formRef = ref(null)

// eslint-disable-next-line
const props = defineProps({
  formType: {
    type: String
  }
})

const isAdd = computed(() => props.formType === FORM_TYPE.ADD)
const isUpdate = computed(() => props.formType === FORM_TYPE.UPDATE)
const isBatch = computed(() => props.formType === FORM_TYPE.BATCH)

const isShowGameGroup = computed(() => {
  // 非素材样式，如【营销主题】标签默认显示
  if (!slots.parent) return true
  // 只有素材样式才有slots.parent
  if (slots.parent) {
    // 素材样式如果选中了一级素材样式，才显示游戏下拉框
    if (isAdd.value && formData.value.parentId) {
      return true
    }

    // 单条修改时，修改的是二级素材样式，才显示游戏下拉框
    // level 赋值: src/views/material/tags/Tags.vue onTableRowUpdate
    if (isUpdate.value && formData.value.level === LEVEL_TYPES.LEVEL_TWO) {
      return true
    }

    // 素材样式批量修改显示
    if (isBatch.value) {
      return true
    }
  }
  return false
})

const initFormFields = () => {
  return {
    parentId: '',
    labels: '', // 新增时的model,可以多个新增
    label: '', // 更新时的model,只能一个更新
    gameIds: [],
    gameGroupId: []
  }
}

const formData = ref(initFormFields())

const onGameGroupChange = (val) => {
  const games = []
  if (Array.isArray(val) && val.length) {
    val.forEach((ret) => {
      const index = gameGroups.value.findIndex((met) => met.id === ret)
      const { gameIds } = gameGroups.value[index]
      games.push(...gameIds.map(Number))
    })
    formData.value.gameIds = Array.from(new Set(games))
  } else {
    formData.value.gameIds = []
  }
}

// eslint-disable-next-line
defineExpose({
  validate: () => {
    return new Promise((resolve, reject) => {
      formRef.value.validate((valid) => {
        if (valid) {
          resolve()
        } else {
          reject(new Error('表单验证失败'))
        }
      })
    })
  },
  getForm: () => formData.value,
  setForm: (data) => {
    formData.value = data
  },
  resetForm: () => {
    formData.value = initFormFields()
  }
})
</script>

<style scoped></style>
